import type { Step } from "react-joyride";

export const provincesTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າຈັດການແຂວງ. ຫນ້ານີ້ຊ່ວຍທ່ານຈັດການແຂວງ ເປີດ/ປິດການສະແດງໃນ dropdown ໄດ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="geo-provinces-toolbar"]',
    content: "ປຸ່ມສ້າງແຂວງໃໝ່. ກົດເພື່ອເພີ່ມແຂວງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="geo-provinces-filter"]',
    content:
      "ກອງຂໍ້ມູນ: ຄົ້ນຫາຊື່, ໂຊນ, ສະຖານະເປີດ/ປິດ. ກົດ 'ລ້າງຕົວກອງ' ເພື່ອລຶບການກອງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="geo-provinces-table"]',
    content: "ຕາຕະລາງແຂວງ. ສາມາດແກ້ໄຂ ຫຼື ເປີດ/ປິດການສະແດງໄດ້ຈາກປຸ່ມການກະທໍາ.",
    placement: "top",
  },
];
